export interface AuthState {
  firstName: string
  tokenIsValid: boolean
  passwordLinkIsSending: boolean
  newPasswordIsSubmitting: boolean
  hasOrcasAccess: boolean
  selectedCookies: Array<string>
}

export enum PasswordValidationError {
  // from django
  TooSimilar = 'The password is too similar to the email.',
  TooShort = 'This password is too short. It must contain at least 8 characters.',
  TooCommon = 'This password is too common.',
  EntirelyNumeric = 'This password is entirely numeric.'
}
